<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Category" :required="true">
              <b-form-select
                @blur="$v.stakeholder.category.$touch"
                :class="{ 'is-invalid': $v.stakeholder.category.$error }"
                v-model="stakeholder.category"
                :options="categories"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.stakeholder.category.required"
              >
                Please select category
              </div>
            </form-group>
            <form-group label="Current Tier" :required="true">
              <b-form-select
                @blur="$v.stakeholder.current_tier.$touch"
                :class="{ 'is-invalid': $v.stakeholder.current_tier.$error }"
                v-model="stakeholder.current_tier"
                :options="tiers"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.stakeholder.current_tier.required"
              >
                Please select current tier
              </div>
            </form-group>
            <form-group label="Desired Tier" :required="true">
              <b-form-select
                @blur="$v.stakeholder.desired_tier.$touch"
                :class="{ 'is-invalid': $v.stakeholder.desired_tier.$error }"
                v-model="stakeholder.desired_tier"
                :options="tiers"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.stakeholder.desired_tier.required"
              >
                Please select desired tier
              </div>
            </form-group>

            <form-group label="Status" :required="true">
              <b-form-select v-model="stakeholder.status" :options="statuses" />
            </form-group>

            <form-group label="Name" :required="true">
              <input
                @blur="$v.stakeholder.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.stakeholder.name.$error }"
                v-model="stakeholder.name"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.stakeholder.name.required"
              >
                Please enter name
              </div>
            </form-group>

            <form-group label="Image">
              <image-upload @files-uploaded=" stakeholder.image_id = $event;
              imageUploading = false; " @files-uploaded-started="imageUploading
              = true" :multiple="false" :imageCrop=true :imageCropRatio=1/1
              :validationState="imageVstate" acceptedTypes="image/*" />
            </form-group>

            <form-group label="Note">
              <textarea-autosize
                class="form-control"
                v-model="stakeholder.note"
              />
            </form-group>


            <form-group label="Contact Person" >
              <input
                class="form-control"
                v-model="stakeholder.contact_person"
              />
            </form-group>

              <form-group label="Phone 1" >
              <input
                class="form-control"
                v-model="stakeholder.phone_1"
              />
            </form-group>

              <form-group label="Phone 2" >
              <input
                class="form-control"
                v-model="stakeholder.phone_2"
              />
            </form-group>

              <form-group label="Email Address" >
              <input
                class="form-control"
                v-model="stakeholder.email_address"
              />
            </form-group>

            <form-group label="Physical Address">
              <textarea-autosize
                class="form-control"
                v-model="stakeholder.physical_address"
              />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import stakeholderRepo from "@/api/repos/stakeholderRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBase,
    formGroup,
    imageUpload,
  },

  computed: {
    imageVstate: function () {
      return null;
    },
  },

  validations: {
    stakeholder: {
      current_tier: {
        required,
      },
      desired_tier: {
        required,
      },
      name: {
        required,
      },
      category: {
        required,
      },
    },
  },

  mounted() {
    this.getData();
  },

  data() {
    return {
      stakeholder: {
        status: "Active",
      },
      statuses: ["Active", "Inactive", "Obsolete"],
      categories: [],
      tiers: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await stakeholderRepo.createGetData();
        this.categories = data.categories;
        this.tiers = data.tiers;
      } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await stakeholderRepo.create(this.stakeholder);
          this.$emit("stakeholderCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

